import { IAction, KEEP_THE_SAME, StateStatus } from 'redux/utils/common';
import * as NewsService from 'services/api/news';
import * as Types from './types';
import {
  ITopicListByCategoryOutput,
  ITopicListOutput,
} from 'services/api/topic';

export interface IState {
  newsDetail: {
    status: StateStatus | null;
    data: NewsService.IDataItems | null;
  };
  latestNews: {
    status: StateStatus | null;
    data: NewsService.IDataItems | null;
  };
  topicList: {
    status: StateStatus | null;
    data: ITopicListOutput | null;
  };
  subscribeToNewsLetter: {
    status: StateStatus | null;
  };
  topicListByCategory: {
    status: StateStatus | null;
    data: ITopicListByCategoryOutput[] | null;
  };
}

const initialState: IState = {
  newsDetail: {
    status: null,
    data: null,
  },
  latestNews: {
    status: null,
    data: null,
  },
  topicList: {
    status: null,
    data: null,
  },
  subscribeToNewsLetter: {
    status: null,
  },
  topicListByCategory: {
    status: null,
    data: null,
  },
};

const NewsShowDetailReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_NEWS_DETAIL:
      return {
        ...state,
        newsDetail: {
          ...state.newsDetail,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_LATEST_NEWS:
      return {
        ...state,
        latestNews: {
          ...state.latestNews,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_TOPIC_LIST:
      return {
        ...state,
        topicList: {
          ...state.topicList,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SUBSCRIBE_TO_NEWS_LETTER:
      return {
        ...state,
        subscribeToNewsLetter: {
          ...state.subscribeToNewsLetter,
          status: action.status || null,
        },
      };
    case Types.SET_TOPIC_LIST_BY_CATEGORY:
      return {
        ...state,
        topicListByCategory: {
          ...state.topicListByCategory,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.topicListByCategory.data
              : action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default NewsShowDetailReducer;
